import '../App.css';
import React from "react";

function YouTubeList(props){
    return(
        <>
            <div className="App">
                {props.youTubeList.map((entry, index) => {
                    return (
                        <div className="youtube-video-container" id={"ytcontainer" + index} key={"ytcontainer" + index}>
                            <div className="youtube-embed-wrapper" id={"ytembedwrapper" + index} key={"ytembedwrapper" + index} dangerouslySetInnerHTML={{__html: entry.youTubeEmbed}}></div>
                            <div className="youtube-description" id={"ytdesc" + index} key={"ytdesc" + index} dangerouslySetInnerHTML={{__html: entry.descriptionHtml}}></div>
                        </div>
                    );
                })}
            </div>
        </>
    );
}

export default YouTubeList;